import reducers from "./reducers";

const paymentReducers = {
  allPaymentPlans: reducers.allPaymentPlansReducer,
  paymentConfirmation: reducers.paymentConfirmationReducer,
  paymentVerification: reducers.paymentVerificationReducer,
};

export { paymentReducers };
